function _class_call_check(instance, Constructor) {
    if (!(instance instanceof Constructor)) {
        throw new TypeError("Cannot call a class as a function");
    }
}
function _defineProperties(target, props) {
    for(var i = 0; i < props.length; i++){
        var descriptor = props[i];
        descriptor.enumerable = descriptor.enumerable || false;
        descriptor.configurable = true;
        if ("value" in descriptor) descriptor.writable = true;
        Object.defineProperty(target, descriptor.key, descriptor);
    }
}
function _create_class(Constructor, protoProps, staticProps) {
    if (protoProps) _defineProperties(Constructor.prototype, protoProps);
    if (staticProps) _defineProperties(Constructor, staticProps);
    return Constructor;
}
function _define_property(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
export var TimedLock = /*#__PURE__*/ function() {
    "use strict";
    function TimedLock(config) {
        _class_call_check(this, TimedLock);
        _define_property(this, "config", void 0);
        _define_property(this, "_locked", void 0);
        _define_property(this, "lockTimerHandler", void 0);
        this.config = config;
        this._locked = false;
        this.lockTimerHandler = null;
    }
    _create_class(TimedLock, [
        {
            key: "lock",
            value: function lock() {
                this.clearLockTimer();
                this._locked = true;
                this.setLockTimer();
            }
        },
        {
            key: "unlock",
            value: function unlock() {
                this.clearLockTimer();
                this._locked = false;
            }
        },
        {
            key: "locked",
            get: function get() {
                return this._locked;
            }
        },
        {
            key: "destroy",
            value: function destroy() {
                this.clearLockTimer();
            }
        },
        {
            key: "setLockTimer",
            value: function setLockTimer() {
                var _this = this;
                this.lockTimerHandler = setTimeout(function() {
                    _this.unlock();
                }, this.config.lockTimeMs);
            }
        },
        {
            key: "clearLockTimer",
            value: function clearLockTimer() {
                if (this.lockTimerHandler) {
                    clearTimeout(this.lockTimerHandler);
                }
                this.lockTimerHandler = null;
            }
        }
    ]);
    return TimedLock;
}();

//# sourceMappingURL=timed-lock.js.map